module.exports = __webpack_public_path__ + "static/homepage-banner-bg-d1d3c19cca718a1d348c6dfc6463de5b.png";